export const environment = {
  production: true,
  userBaseUrl: 'https://auth.api.stage.tsin.ca/api',
  apiBaseUrl: 'https://wwus.api.stage.tsin.ca/api',
  userMgtUrl: 'https://auth.stage.tsin.ca/login/work-with-us',
  userMgtCreateUrl: 'https://auth.stage.tsin.ca/create-account/work-with-us',
  paymentUrl: 'https://pro.api.stage.tsin.ca',
  authBaseUrl: 'https://auth.api.stage.tsin.ca/api',
  learningBaseUrl: 'https://lms.api.stage.tsin.ca/api',
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
};
